import {initFlowbite} from "flowbite";

initFlowbite();
